const templateLoaded = {
    svg: '<svg data-name="Layer 1" style="width:1.00rem; height:1.00rem;" viewBox="0 0 13.33 16"><polygon points="10.96 6.02 9.88 4.98 5.62 9.42 3.46 7.16 2.38 8.2 5.62 11.58 10.96 6.02"/><path d="M13.33 16V4l-4-4H0v16ZM8.7 1.6l3 3.06v9.74H1.6V1.6Z"/></svg>',
};

export { templateLoaded as default };
